module.exports = __webpack_public_path__ + "img/SILENT_A1010.914e018c.png";